import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    CardTitle,
    CardSubtitle,
    Container,
    Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-tagsinput/react-tagsinput.css";

import showNotification from "../../helpers/show_notification";

import { postSubmitForm } from "../../helpers/forms_helper";
import exportFromJSON from "export-from-json";

const AddProductUnit = (props) => {

    useEffect(() => {
        loadAllProductUnits();
    }, []);

    const [allUnits, setAllUnits] = useState([]);
    const loadAllProductUnits = async (e, v) => {
        let url = process.env.REACT_APP_BASEURL + "productunits/getall";
        let response = await postSubmitForm(url, "");
        if (response.status === 1) {
            setAllUnits(response.data);
        } else {
            showNotification(response.message, "Error");
        }
    };
    const refContainer = useRef(null);

    const [isLoading , setIsLoading] = useState(false)
    const handleValidSubmit = async (e, v) => {
        try {
            const object = {
                unit: v.name,
            };
            setIsLoading(true)
            let url = process.env.REACT_APP_BASEURL + "productunits/insert";
            let response = await postSubmitForm(url, object);
            if (response.status === 1) {
                loadAllProductUnits();
                showNotification(response.message, "Success");
                refContainer.current.reset();
            } else {
                showNotification(response.message, "Error");
            }
        } catch (error) {
            showNotification(error.message, "Error");
        } finally {
            setIsLoading(false)
        }
    };

    const columns = [
        {
            text: "#",
            dataField: "_id",
            formatter: (cell, row, rowIndex) => {
                return rowIndex + 1
            },
            headerStyle: (colum, colIndex) => {
                return { width: "1%" };
            },
            //   hidden: true,
        },
        {
            text: props.t("Unit Name"),
            //formatter: employeeFormatter,
            dataField: "unit",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "16%" };
            },
        },
    ];

    const handleDownload = async () => {
        const fileName = "Products_UOM";
        const exportType = "xls";

        let data_to_export = allUnits;

        if (data_to_export) {
            var data = [];
            JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
                data.push({
                    name: v.unit
                });
            });

            exportFromJSON({ data, fileName, exportType });
        }
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={props.t("Unit of Measurement")}
                        breadcrumbItem={props.t("Add Product Unit")}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <AvForm onValidSubmit={handleValidSubmit} ref={refContainer}>
                                        <CardTitle>{props.t("Add Unit")}</CardTitle>
                                        <CardSubtitle className="mb-3">
                                            {props.t(
                                                "Enter the following details to add a new product unit"
                                            )}
                                        </CardSubtitle>
                                        <Row>
                                            <Col lg={4}>
                                                <AvField
                                                    name="name"
                                                    label={props.t("Unit")}
                                                    placeholder={props.t("Enter Unit Name")}
                                                    type="text"
                                                    validate={{
                                                        required: {
                                                            value: true,
                                                            errorMessage: props.t("Unit cannot be empty"),
                                                        },
                                                    }}
                                                />
                                            </Col>


                                            <Col lg={8}>
                                            <div className="mt-4">
                        <Button type="submit" color="primary" className="mr-1" disabled={isLoading} style={{width:"100px"}}>
                          { isLoading ? <Spinner size={"sm"}/> :props.t("Submit")}
                        </Button>
                      </div>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <Row className="mb-2">
                                        <Col sm="4">
                                            <Button
                                                type="submit"
                                                className="btn btn-sm btn-secondary"
                                                onClick={handleDownload}
                                            >
                                                <i className="mdi mdi-file-export"></i>{" "}
                                                {props.t("Export CSV")}
                                            </Button>

                                            <div className="search-box mr-2 mb-2 d-inline-block">
                                                <div className="position-relative"></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <CardTitle>{props.t("Existing Product Units")} </CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {props.t("View all your existing units here")}
                                    </CardSubtitle>
                                    <BootstrapTable
                                        bootstrap4
                                        keyField="_id"
                                        data={allUnits && allUnits}
                                        columns={columns}
                                        noDataIndication={props.t("No data to display.")}
                                        striped
                                        hover
                                        condensed
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(connect(null, {})(withNamespaces()(AddProductUnit)));
